import React from 'react';
import SubServices from './sub-services';
const WhyMeetWithUs = () => {
    return (
        <div className="section-py bg-grey dark:bg-gray-800">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Meet With Us?
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2">
                    <SubServices
                        path={'/img/technology/ic-tailored-solutions.svg'}
                        height={64}
                        width={64}
                        alt="Tailored Solutions"
                        title="Tailored Solutions"
                        serviceName="Tailored Solutions"
                        serviceDescription="Whether you're looking to streamline processes or innovate new products, we provide solutions crafted specifically for your needs."
                    />
                    <SubServices
                        path={'/img/technology/ic-future-focused.svg'}
                        height={64}
                        width={64}
                        alt="Innovative Expertise"
                        title="Innovative Expertise"
                        serviceName="Innovative Expertise"
                        serviceDescription="With successful projects delivered across industries, our deep technical knowledge ensures you're partnering with the best."
                    />
                    <SubServices
                        path={'/img/technology/ic-real-time.svg'}
                        height={64}
                        width={64}
                        alt="Real-Time Collaboration"
                        title="Real-Time Collaboration"
                        serviceName="Real-Time Collaboration"
                        serviceDescription="Access live demos, explore technology-driven strategies, and uncover partnership opportunities—all customized to your goals."
                    />
                    <SubServices
                        path={'/img/technology/ic-innovation-expertise.svg'}
                        height={64}
                        width={64}
                        alt="Future-Focused Innovation"
                        title="Future-Focused Innovation"
                        serviceName="Future-Focused Innovation"
                        serviceDescription="Let's collaborate on forward-thinking solutions designed to drive growth, enhance customer experiences, and position your business ahead of the curve."
                    />
                </div>
            </div>
        </div>
    );
};

export default WhyMeetWithUs;
